var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"down-arrow","d":"M5.817,7,0,12.777,1.226,14l7-7-7-7L0,1.226l4.9,4.9Z","transform":"translate(14) rotate(90)","fillRule":"evenodd"}));
}

ChevronDown.defaultProps = {"width":"14","height":"8.225","viewBox":"0 0 14 8.225"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
